module.exports = __webpack_public_path__ + "img/fas-arrow-down-to-bracket.449f47fd.svg";